module.exports = __webpack_public_path__ + "static/media/wrong.5ec7add5.png";